import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取生产订单信息*/
export function GetProductionorder(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/productionorder/",
        params:data
    })
}

/*获取生产订单供应商信息*/
export function SupplierInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/optionssupplier/",
        params:data
    })
}

/*获取生产订单编辑信息*/
export function ProductionorderEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/productionorderedit/",
        params:data
    })
}

/*生产订单编辑*/
export function ProductionorderEdit(data = {}){
    let params = new URLSearchParams();
    params.append('orderid',data.orderid);
    params.append('quantity',data.quantity);
    params.append('orderdate',data.orderdate);
    params.append('deliverydate',data.deliverydate);
    params.append('material',data.material);
    params.append('marking',data.marking);
    params.append('shape',data.shape);
    params.append('size',data.size);
    params.append('grains',data.grains);
    params.append('totalgrains',data.totalgrains);
    params.append('electroplate',data.electroplate);
    params.append('fingerring',data.fingerring);
    params.append('chain',data.chain);
    params.append('notes',data.notes);
    params.append('maketemplatetag',data.maketemplatetag);
    params.append('customer_ordernumber',data.customer_ordernumber);
return instance.request({
        method: "post",
        url: "ordermanage/productionorderedit/",
        data:params
    })
}

/*获取订单增加数编辑信息*/
export function ProductionorderInsertdataInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/productionorderInsertdata/",
        params:data
    })
}

/*订单增加数*/
export function ProductionorderInsertdata(data = {}){
    let params = new URLSearchParams();
    params.append('ordernumber',data.ordernumber);
    params.append('quantity',data.quantity);
return instance.request({
        method: "post",
        url: "ordermanage/productionorderInsertdata/",
        data:params
    })
}

/*石资料新增*/
export function StonedataAdd(data){
return instance.request({
        method: "post",
        url: "ordermanage/stonedataadd/",
        data:data
    })
}

/*石资料插入*/
export function StonedataInsert(data){
return instance.request({
        method: "post",
        url: "ordermanage/stonedatainsert/",
        data:data
    })
}

/*生产订单新增*/
export function ProductionorderAdd(data){
return instance.request({
        method: "post",
        url: "ordermanage/productionorderadd/",
        data:data
    })
}

/*生产订单删除*/
export function ProductionorderDel(data = {}){
    let params = new URLSearchParams();
    params.append('orderid',data.orderid)
return instance.request({
        method: "post",
        url: "ordermanage/productionorderdel/",
        data:params
    })
}

/*生产订单复制*/
export function ProductionorderCopy(data = {}){
    let params = new URLSearchParams();
    params.append('orderid',data.orderid)
return instance.request({
        method: "post",
        url: "ordermanage/productionordercopy/",
        data:params
    })
}

/*字印附件删除*/
export function MarkingattachmentDel(data = {}){
    let params = new URLSearchParams();
    params.append('markingattachmentid',data.markingattachmentid)
return instance.request({
        method: "post",
        url: "ordermanage/markingattachmentdel/",
        data:params
    })
}

/*石资料删除*/
export function StonedataDel(data = {}){
    let params = new URLSearchParams();
    params.append('stonedataid',data.stonedataid)
return instance.request({
        method: "post",
        url: "ordermanage/stonedatadel/",
        data:params
    })
}

/*获取订单件数信息*/
export function QuantityInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/quantity/",
        params:data
    })
}

/*获取石资料信息*/
export function StonedataInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/stonedata/",
        params:data
    })
}

/*获取字印附件信息*/
export function MarkingattachmentInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/markingattachment/",
        params:data
    })
}

/*接收生产订单*/
export function ProductionorderReceive(data = {}){
return instance.request({
        method: "post",
        url: "ordermanage/productionorderreceive/",
        data:data,
    })
}

/*导出生产订单信息*/
export function ExportProductionorder(data = {}){
return instance.request({
        method: "post",
        url: "ordermanage/productionorderexport/",
        data:data,
        responseType: 'blob',
        timeout:360000
    })
}

/*导出生产订单信息*/
export function ExportProductionorderGold(data = {}){
return instance.request({
        method: "post",
        url: "ordermanage/productionorderGoldexport/",
        data:data,
        responseType: 'blob',
        timeout:360000
    })
}

/*导出跟踪单信息*/
export function ExportProductionorderTrack(data = {}){
return instance.request({
        method: "post",
        url: "ordermanage/productionorderTrackexport/",
        data:data,
        responseType: 'blob',
        timeout:360000
    })
}

/*上传字印附件*/
export function UploadMarkingattachment(data = {}){
return instance.request({
        method: "post",
        url: "ordermanage/markingattachmentupload/",
        data:data
    })
}

/*获取石资料编辑信息*/
export function StonedataEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/stonedataedit/",
        params:data
    })
}

/*石资料编辑*/
export function StonedataEdit(data = {}){
    let params = new URLSearchParams();
    params.append('stonedataid',data.stonedataid);
    params.append('shape',data.shape);
    params.append('size',data.size);
    params.append('grains',data.grains);
    params.append('totalgrains',data.totalgrains);
    params.append('colour',data.colour);
    params.append('quality',data.quality);
return instance.request({
        method: "post",
        url: "ordermanage/stonedataedit/",
        data:params
    })
}

/*获取一口价信息*/
export function getFixedprice(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/getFixedprice/",
        params:data
    })
}

/*订单新增一口价*/
export function FixedpriceAdd(data){
return instance.request({
        method: "post",
        url: "ordermanage/fixedpriceadd/",
        data:data
    })
}
